import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Register from "../components/Register/Register";
import Login from "../components/Login/Login";
import PrivateRoute from "./PrivateRoute";
import Painel from "../features/UserPanel/Painel/Painel";
import EsqueciSenha from "../components/EsqueciSenha/EsqueciSenha";
import ResetPassword from "../components/ResetPassword/ResetPassword";
import Admin from "../features/AdminPanel/Admin/Admin";
import PaymentSuccess from "../features/UserPanel/pagamentos/PaymentSuccess";
import PaymentFailed from "../features/UserPanel/pagamentos/PaymentFailed";

function AppRoutes() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Rota Inicial Redirecionando para /login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Rotas Públicas */}
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/esqueci-senha" element={<EsqueciSenha />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/pagamento/sucesso" element={<PaymentSuccess />} />
        <Route path="/pagamento/erro" element={<PaymentFailed />} />
        {/* Rota Protegida para Usuários Autenticados */}
        <Route path="/painel" element={<PrivateRoute />}>
          <Route index element={<Painel />} />
          {/* Nova rota para pagamento */}
          <Route path="pagamento" element={<Painel />} />
        </Route>

        {/* Rota Protegida para Administradores */}
        <Route
          path="/admin"
          element={<PrivateRoute requiredRole="admin" />}
        >
          <Route index element={<Admin />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default AppRoutes;
